export default {"src":"/_next/static/media/0xba5ddd1f9d7f570dc94a51479a000e3bce967196.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};